import dateFnsFormat from 'date-fns/format';

import Settings from 'config/settings';

export const getDateString = (date, format = Settings.DATE_FORMAT) =>
  date && dateFnsFormat(date, format);

export const capitalizeFirstLetter = (string) =>
  typeof string === 'string' ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : '';
